import React from "react";

import { useCruiseContext } from "../../../provider/cruise.provider";

export default function Title() {
  const { selectedAnswer, groupedMagnoliaData } = useCruiseContext();
  const { title } = groupedMagnoliaData[selectedAnswer].descriptionSection;

  return (
    <h2
      className={`
        md:!text-3xl font-header-font ${
          selectedAnswer === 0 ? "text-center" : "text-center md:text-left"
        } leading-[21px] 
        md:leading-[34.1px] text-[20px] md:mb-spacing-xs mb-spacing-m text-surface-neutral-option-1
      `}
    >
      {title}
    </h2>
  );
}
